import {
  getCurrentRegionCode,
  getGlobalRegionCode,
} from '@ac/library-utils/dist/utils/multi-region';

export const isGlobalRegion = (
  regionCode: string = getCurrentRegionCode()
): boolean => regionCode === getGlobalRegionCode();
